import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import submitTestAPI, { submitTestAPINew } from '../../../../services/api/fytnServices';
import { toast, ToastContainer } from "react-toastify";

const TOAST_ID = 'unique-toast-id';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialog({ open, 
    setOpen,  user, 
    formattedData,
    selectedAnswersPartI,
    selectedAnswersPartII,
    selectedAnswersPartIII,
    setReload


 }) {
    const [isSubmitting, setIsSubmitting] = React.useState(false); 


    const handleSubmitTest = async () => {

    if (Object.keys(selectedAnswersPartI).length === 0) {
        toast.dismiss(TOAST_ID);
        toast.error("Part I - Incomplete", {
            style: {
                display: 'flex',
                background: '#fff',
                color: '#000',
                padding: '10px 14px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
            position: "top-center",
            autoClose: 1000,
        });
        return;
    }

    if (Object.keys(selectedAnswersPartII).length === 0) {
        toast.dismiss(TOAST_ID);
        toast.error("Part II - Incomplete", {
            style: {
                display: 'flex',
                background: '#fff',
                color: '#000',
                padding: '10px 14px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
            position: "top-center",
            autoClose: 1000,
        });
        return;
    }

    if (selectedAnswersPartIII.length === 0) {
        toast.dismiss(TOAST_ID);
        toast.error("Part III - Incomplete", {
            style: {
                display: 'flex',
                background: '#fff',
                color: '#000',
                padding: '10px 14px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
            position: "top-center",
            autoClose: 1000,
        });
        return;
    }

        setIsSubmitting(true); 
        try{

            const response = await submitTestAPINew(user.USER_MASTER_ID,user.master_id,
                 formattedData);
           
            toast.dismiss(TOAST_ID);

            toast.success("Test Submitted Successfully", {
                toastId: TOAST_ID,
                style: {
                    display: 'flex',
                    background: '#f2f0f0',
                    color: '#141414',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                },
                position: "top-center",
                autoClose: 1000,
            });
setReload(true)
              sessionStorage.setItem('resultsData', JSON.stringify(response.data));

            if(response.status===200)
             {  setOpen(false); 
                  window.location.href='/thank-you'
                return } 

         } catch (error) {
             const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
             console.log("Error occurred:", error);

            toast.error(errorMessage, {
                style: {
                    display: 'flex',
                    background: '#fff',
                    color: '#000',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                },
                position: "top-center",
                autoClose: 1000,
            });
         } finally {
             setIsSubmitting(false); // Reset loading state
         }
    };

    const handleClose = () => {
        setOpen(false); 
    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={(event, reason) => {
                    if (reason === "backdropClick") {
                        return; // Prevent dialog from closing on outside click
                    }
                    handleClose(); // Handle other close actions
                }}                
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle
                    sx={{
                        fontSize: "20px",
                        fontWeight: "700",
                    }}
                >
                    {"Submit Test"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to submit your results?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} aria-label="Cancel submission" disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmitTest}
                        disabled={isSubmitting}
                        aria-label="Submit test"
                    >
                        {isSubmitting ? "Submitting..." : "Submit"} 
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer />
        </React.Fragment>
    );
}
